/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PropertyTypeItemDto } from './PropertyTypeItemDto';
import {
    PropertyTypeItemDtoFromJSON,
    PropertyTypeItemDtoFromJSONTyped,
    PropertyTypeItemDtoToJSON,
    PropertyTypeItemDtoToJSONTyped,
} from './PropertyTypeItemDto';
import type { ListingStatusItemDto } from './ListingStatusItemDto';
import {
    ListingStatusItemDtoFromJSON,
    ListingStatusItemDtoFromJSONTyped,
    ListingStatusItemDtoToJSON,
    ListingStatusItemDtoToJSONTyped,
} from './ListingStatusItemDto';

/**
 * 
 * @export
 * @interface MapPropertyItemDto
 */
export interface MapPropertyItemDto {
    /**
     * Unique property identifier
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    id: string;
    /**
     * MLS listing ID
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    mlsId: string;
    /**
     * MLS source identifier
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    mlsSource: string;
    /**
     * Primary address line
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    addressLine1: string;
    /**
     * Secondary address line
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    addressLine2?: string;
    /**
     * Number of bedrooms
     * @type {number}
     * @memberof MapPropertyItemDto
     */
    numBedrooms: number;
    /**
     * Number of bathrooms
     * @type {number}
     * @memberof MapPropertyItemDto
     */
    numBathrooms: number;
    /**
     * City name
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    city: string;
    /**
     * State abbreviation
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    state: string;
    /**
     * ZIP code
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    zipCode: string;
    /**
     * Listing status information
     * @type {ListingStatusItemDto}
     * @memberof MapPropertyItemDto
     */
    listingStatus: ListingStatusItemDto;
    /**
     * Property type information (deprecated, use propertyTypeRaw and propertySubTypeRaw)
     * @type {PropertyTypeItemDto}
     * @memberof MapPropertyItemDto
     * @deprecated
     */
    propertyType: PropertyTypeItemDto;
    /**
     * 
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    propertyTypeRaw: string;
    /**
     * 
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    propertySubTypeRaw: string;
    /**
     * Internal square footage
     * @type {number}
     * @memberof MapPropertyItemDto
     */
    internalSize: number;
    /**
     * URL to the cover photo
     * @type {string}
     * @memberof MapPropertyItemDto
     */
    coverPhotoUrl: string;
    /**
     * Current price
     * @type {number}
     * @memberof MapPropertyItemDto
     */
    currentPrice: number;
    /**
     * Sold price
     * @type {number}
     * @memberof MapPropertyItemDto
     */
    soldPrice: number;
    /**
     * List price
     * @type {number}
     * @memberof MapPropertyItemDto
     */
    listPrice: number;
    /**
     * Property latitude coordinate
     * @type {number}
     * @memberof MapPropertyItemDto
     */
    latitude: number;
    /**
     * Property longitude coordinate
     * @type {number}
     * @memberof MapPropertyItemDto
     */
    longitude: number;
}

/**
 * Check if a given object implements the MapPropertyItemDto interface.
 */
export function instanceOfMapPropertyItemDto(value: object): value is MapPropertyItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('mlsId' in value) || value['mlsId'] === undefined) return false;
    if (!('mlsSource' in value) || value['mlsSource'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('numBedrooms' in value) || value['numBedrooms'] === undefined) return false;
    if (!('numBathrooms' in value) || value['numBathrooms'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('listingStatus' in value) || value['listingStatus'] === undefined) return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined) return false;
    if (!('propertyTypeRaw' in value) || value['propertyTypeRaw'] === undefined) return false;
    if (!('propertySubTypeRaw' in value) || value['propertySubTypeRaw'] === undefined) return false;
    if (!('internalSize' in value) || value['internalSize'] === undefined) return false;
    if (!('coverPhotoUrl' in value) || value['coverPhotoUrl'] === undefined) return false;
    if (!('currentPrice' in value) || value['currentPrice'] === undefined) return false;
    if (!('soldPrice' in value) || value['soldPrice'] === undefined) return false;
    if (!('listPrice' in value) || value['listPrice'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function MapPropertyItemDtoFromJSON(json: any): MapPropertyItemDto {
    return MapPropertyItemDtoFromJSONTyped(json, false);
}

export function MapPropertyItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MapPropertyItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'mlsId': json['mlsId'],
        'mlsSource': json['mlsSource'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'numBedrooms': json['numBedrooms'],
        'numBathrooms': json['numBathrooms'],
        'city': json['city'],
        'state': json['state'],
        'zipCode': json['zipCode'],
        'listingStatus': ListingStatusItemDtoFromJSON(json['listingStatus']),
        'propertyType': PropertyTypeItemDtoFromJSON(json['propertyType']),
        'propertyTypeRaw': json['propertyTypeRaw'],
        'propertySubTypeRaw': json['propertySubTypeRaw'],
        'internalSize': json['internalSize'],
        'coverPhotoUrl': json['coverPhotoUrl'],
        'currentPrice': json['currentPrice'],
        'soldPrice': json['soldPrice'],
        'listPrice': json['listPrice'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
    };
}

export function MapPropertyItemDtoToJSON(json: any): MapPropertyItemDto {
    return MapPropertyItemDtoToJSONTyped(json, false);
}

export function MapPropertyItemDtoToJSONTyped(value?: MapPropertyItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'mlsId': value['mlsId'],
        'mlsSource': value['mlsSource'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'numBedrooms': value['numBedrooms'],
        'numBathrooms': value['numBathrooms'],
        'city': value['city'],
        'state': value['state'],
        'zipCode': value['zipCode'],
        'listingStatus': ListingStatusItemDtoToJSON(value['listingStatus']),
        'propertyType': PropertyTypeItemDtoToJSON(value['propertyType']),
        'propertyTypeRaw': value['propertyTypeRaw'],
        'propertySubTypeRaw': value['propertySubTypeRaw'],
        'internalSize': value['internalSize'],
        'coverPhotoUrl': value['coverPhotoUrl'],
        'currentPrice': value['currentPrice'],
        'soldPrice': value['soldPrice'],
        'listPrice': value['listPrice'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}

